import { CUSTOM_SCHEDULE_ATTRIBUTE, parseScheduleWindows } from '@provision/sidekick-utils';
import type { ComponentProps } from 'react';
import { ScheduleConditionEditor } from 'src/components/ScheduleConditionEditor';
import { CustomValueEditor } from 'src/pages/Settings/rules/rules-form-ui-controls';

type PolicyConditionValueEditorProps = ComponentProps<typeof CustomValueEditor>;

/** The rules engine's value editor, except that a Custom schedule row edits its windows in place. */
export const PolicyConditionValueEditor = (props: PolicyConditionValueEditorProps) => {
  if (props.field?.value === CUSTOM_SCHEDULE_ATTRIBUTE) {
    return (
      <ScheduleConditionEditor
        className={props.className}
        windows={parseScheduleWindows(props.value)}
        onChange={props.handleOnChange}
      />
    );
  }

  return <CustomValueEditor {...props} />;
};
